export const stripBorders = {
  boxShadow: 'none',
  outline: 'none',
  border: 'none',
};
